import React, { useEffect } from "react";
import CashflowProjectionsChart from "./CashflowProjectionsChart";
import emptyStateMixedBar from "../assets/empty-state-mixed-bar.svg";

const CashFlowProjection = ({ cfs }) => {
  const [hasData, setHasData] = React.useState(false);

  useEffect(() => {
    setHasData(cfs && Object.keys(cfs).length > 0);
  }, [cfs]);

  return (
    <div>
      <h2
        className="bg-vennre-blue text-sm md:text-lg text-white font-semibold px-6 py-2 sm:rounded-t-lg"
        data-section-title
      >
        Cash Flow Overview
      </h2>
      <div className="bg-white lg:p-6 shadow-md rounded-lg">
        <div className="flex justify-center items-center rounded-lg">
          {hasData ? (
            <div className="w-full pb-4">
              <CashflowProjectionsChart cfs={cfs} />
            </div>
          ) : (
            <div>
              <img
                src={emptyStateMixedBar}
                alt="No Data"
                className="h-40 w-40 mx-auto mt-4 lg:mt-0"
              />
              <p className="m-4 text-slate-500 text-center">
                Start investing for sustainable wealth now.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CashFlowProjection;
